"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function ExpandCardButton({ expanded, expandable, ellipsis, onClick, }) {
    const expandButtonRef = (0, react_1.useRef)(null);
    const events = (0, ui_1.getPointersEvents)();
    const onClickHandler = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        onClick();
    }, [onClick]);
    const onClickNativeHandler = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
    }, []);
    (0, ui_1.useEvent)(expandButtonRef, events.down, onClickNativeHandler);
    const collapsedIcon = ellipsis ? ui_1.Icons.Three_Dots : ui_1.Icons.Arrow_Down;
    return ((0, jsx_runtime_1.jsx)(Button, { ref: expandButtonRef, visible: expandable, onClick: onClickHandler, role: "button", "aria-label": "Expand", "data-e2e": 'ExpandCardButton_Button', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: expanded ? ui_1.Icons.Arrow_Up : collapsedIcon, "data-e2e": 'ExpandCardButton_ButtonIcon' }) }));
}
exports.default = ExpandCardButton;
const Button = styled_components_1.default.div `
  position: absolute;
  bottom: -30px;
  left: calc(50% - 30px);

  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;

  width: 60px;
  height: 30px;

  color: ${({ theme }) => theme.text};

  &::before {
    position: absolute;
    top: 0;
    left: calc(50% - 20px);

    width: 40px;
    height: 20px;

    background: ${({ theme }) => theme.backgroundSecondary};

    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;

    box-shadow: ${({ theme }) => theme.tools.pen.button.shadow};

    content: '';
  }
`;
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  /** z-index to place icon over button **/
  z-index: 1;

  width: 16px;
  height: 16px;

  margin: 0 auto auto auto;
`;
